import React, { FC, useEffect, useRef, useState } from "react";

import {
  SpinContainer,
  VideoContainer,
} from "./gallery-media-tabs/gallery-media-tabs.styled";

const IFRAME_TOP_BOTTOM_SPACING = 56 * 2;

interface IframeProps {
  media: string | null;
  iframeRef?: React.RefObject<HTMLIFrameElement>;
  iframeType: "VIDEO" | "SPIN";
}

interface IframeDimensions {
  width: number;
  height: number;
}
function calculateIframeDimensions(iframeElement: HTMLIFrameElement | null) {
  const windowDimensions = {
    width: window.innerWidth,
    height: window.innerHeight - 110,
  };

  const iframeDimensions = {
    width: iframeElement?.clientWidth,
    height: iframeElement?.offsetHeight,
  };

  const maxIframeHeight = windowDimensions.height - IFRAME_TOP_BOTTOM_SPACING;

  if (!window || !iframeDimensions.width || !iframeDimensions.height) {
    return null;
  }

  return {
    width: Math.min((maxIframeHeight / 9) * 16, iframeDimensions.width),
    height: Math.min(maxIframeHeight, iframeDimensions.height),
  };
}

function getIframeWrapperType(type: IframeProps["iframeType"]) {
  switch (type) {
    case "VIDEO": {
      return VideoContainer;
    }
    case "SPIN": {
      return SpinContainer;
    }
  }
}
export const IframeWrapper: FC<IframeProps> = ({
  media,
  iframeRef,
  iframeType,
}) => {
  const containerRef = useRef(null);
  const [iframeElementDimensions, setIframeElementDimensions] =
    useState<IframeDimensions | null>(null);
  const IframeContainer = getIframeWrapperType(iframeType);

  useEffect(() => {
    const getIframeDimensions = () => {
      setIframeElementDimensions(
        calculateIframeDimensions(containerRef.current),
      );
    };

    getIframeDimensions();

    window.addEventListener("resize", getIframeDimensions);

    return () => {
      window.removeEventListener("resize", getIframeDimensions);
    };
  }, [iframeRef]);

  if (!media) {
    return null;
  }

  return (
    <IframeContainer ref={containerRef}>
      <iframe
        ref={iframeRef}
        src={media}
        title="Video"
        frameBorder="0"
        allowFullScreen
        scrolling="no"
        style={{
          ...iframeElementDimensions,
        }}
      />
    </IframeContainer>
  );
};
